import { collection, doc, setDoc, getDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";
import type { User } from "firebase/auth";

export const saveUserProfile = async (user: User, name?: string, firstName?: string, address?: any, role: 'user' | 'admin' = 'user') => {
  try {
    const userRef = doc(db, "users", user.uid);
    await setDoc(userRef, {
      uid: user.uid,
      email: user.email,
      name: name || user.displayName || '',
      firstName: firstName || '',
      address: address || {},
      role: role,
      createdAt: serverTimestamp(),
      lastLoginAt: serverTimestamp(),
      isActive: true
    });
    console.log("Profil utilisateur sauvegardé avec rôle:", role);
  } catch (error) {
    console.error("Erreur sauvegarde profil:", error);
    throw error;
  }
};

export const getUserProfile = async (userId: string) => {
  try {
    const userRef = doc(db, "users", userId);
    const userDoc = await getDoc(userRef);
    if (userDoc.exists()) {
      return userDoc.data();
    }
    return null;
  } catch (error) {
    console.error("Error getting user profile:", error);
    return null;
  }
};

export const updateUserLastLogin = async (user: User) => {
  try {
    const userRef = doc(db, "users", user.uid);
    await setDoc(userRef, {
      lastLoginAt: serverTimestamp()
    }, { merge: true });
    return true;
  } catch (error) {
    console.error("Error updating last login:", error);
    return false;
  }
};

export const checkUserRole = async (userId: string): Promise<'user' | 'admin' | null> => {
  try {
    const userProfile = await getUserProfile(userId);
    return userProfile?.role || null;
  } catch (error) {
    console.error("Error checking user role:", error);
    return null;
  }
};

export const createAdminUser = async (user: User, name?: string, firstName?: string, address?: any) => {
  return await saveUserProfile(user, name, firstName, address, 'admin');
};

export const updateUserRole = async (userId: string, role: 'user' | 'admin') => {
  try {
    const userRef = doc(db, "users", userId);
    await setDoc(userRef, {
      role: role
    }, { merge: true });
    console.log(`Rôle de l'utilisateur ${userId} mis à jour:`, role);
    return true;
  } catch (error) {
    console.error("Erreur mise à jour rôle:", error);
    return false;
  }
};
